<section *transloco="let t" class="relative pt-12 pb-16 sm:pt-16 sm:pb-24">
  <!-- Decorative Ring -->
  <div
    aria-hidden="true"
    class="pointer-events-none absolute inset-y-0 left-1/2 -z-10 w-screen -translate-x-1/2 overflow-x-clip"
  >
    <img
      src="/assets/images/home/decor/half-ring-1.webp"
      alt=""
      class="absolute -left-16 top-10 w-[13rem] opacity-70 sm:-left-20 sm:top-16 sm:w-[22rem] lg:-left-14 lg:w-[26rem]"
    />
  </div>

  <!-- Title & Subtitle -->
  <div class="mx-auto max-w-3xl text-center">
    <h2 class="text-3xl font-extrabold leading-tight tracking-tight text-slate-900 sm:text-5xl">
      {{ t('home.whyChoose.title') }}
    </h2>
    <p class="mt-4 text-base text-slate-600 sm:mt-5 sm:text-xl">
      {{ t('home.whyChoose.subtitle') }}
    </p>
  </div>

  <!-- Features -->
  <div class="mt-10 grid gap-5 sm:mt-14 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3 lg:gap-8">
    @for (feature of features; track feature.key) {
      <article
        class="flex flex-col rounded-xl border p-6 sm:p-10"
        [class]="[feature.tint, feature.shadow, feature.border]"
      >
        <!-- Icon & Image -->
        <div class="mb-3 flex items-start justify-between gap-4">
          <img
            [src]="feature.icon"
            alt=""
            width="96"
            height="96"
            class="h-20 w-20 shrink-0 sm:h-24 sm:w-24"
          />
          <img
            [src]="feature.image"
            alt=""
            class="w-auto max-w-[55%] object-contain object-right"
            [class]="feature.imageSize"
          />
        </div>

        <!-- Title -->
        <h3 class="text-xl font-semibold leading-snug tracking-tight text-slate-800 sm:text-2xl">
          {{ t('home.whyChoose.features.' + feature.key + '.title') }}
        </h3>

        <!-- Description -->
        <p class="mt-2 text-base text-slate-800 sm:text-[19px]">
          {{ t('home.whyChoose.features.' + feature.key + '.description') }}
        </p>

        <!-- Extra -->
        @if (feature.hasExtra) {
          <p class="mt-4 text-base text-slate-800 sm:text-[19px]">
            {{ t('home.whyChoose.features.' + feature.key + '.extra') }}
          </p>
        }
      </article>
    }
  </div>
</section>
